import { IApplicationState, TCardId } from '../../../../../../types/types';

export const getDraggableCardId = (
    state: IApplicationState
): TCardId => {
    return state.kanbanView.draggableCardId;
};
